import { render, staticRenderFns } from "./CompanyEditUsers.vue?vue&type=template&id=a28cd7ba&scoped=true&"
import script from "./CompanyEditUsers.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditUsers.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyEditUsers.vue?vue&type=style&index=0&id=a28cd7ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28cd7ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a28cd7ba')) {
      api.createRecord('a28cd7ba', component.options)
    } else {
      api.reload('a28cd7ba', component.options)
    }
    module.hot.accept("./CompanyEditUsers.vue?vue&type=template&id=a28cd7ba&scoped=true&", function () {
      api.rerender('a28cd7ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditUsers.vue"
export default component.exports